const PLATFORM_ADMIN_ROLE = "PlatformAdmin";

/**
 * Fehlerstacktraces gehören nicht in Mandantenoberflächen. Plattformadministratoren benötigen
 * sie dagegen unmittelbar für die Zuordnung zur protokollierten Fehler-ID. Die echte
 * Berechtigung bleibt serverseitig; diese Funktion steuert ausschließlich die Darstellung.
 */
export function shouldShowClientErrorDetails(account: { role?: string; isPlatformAdmin?: boolean } | null | undefined) {
  return import.meta.env.DEV || account?.isPlatformAdmin === true || account?.role === PLATFORM_ADMIN_ROLE;
}
